import { action, observable } from "mobx";

import { GET_HOME_OWNER_NAMES } from "../../graphql-documents/getHomeOwnerNames.query";
import { VALIDATE_HOME_CLAIM } from "../../graphql-documents/validateHomeClaim.mutation";
import { getSelectedNameSlot } from "../../utilities/getSelectedNameSlot";
import { ownerNameToGraphQL } from "../../utilities/mapFormValuesToGraphQL";

class ValidationStore {
  @observable propertyId;
  @observable userId;

  @observable loading = false;
  @observable ownerNameOptions = [];
  @observable error = null;

  @observable hasCompletedValidation = false;

  constructor({
    analyticsService,
    graphqlMutationService,
    graphqlQueryService
  }) {
    this.graphqlQueryService = graphqlQueryService;
    this.graphqlMutationService = graphqlMutationService;
    this.analyticsService = analyticsService;
  }

  @action.bound
  initialize({ hasCompletedValidation, propertyId, userId }) {
    this.propertyId = propertyId;
    this.userId = userId;
    this.hasCompletedValidation = hasCompletedValidation;
  }

  @action.bound
  setHasCompletedValidation(value) {
    this.hasCompletedValidation = value;
  }

  @action.bound
  setError(value) {
    this.error = value;
  }

  @action.bound
  setLoading(value) {
    this.loading = value;
  }

  @action.bound
  setPropertyId(value) {
    this.propertyId = value;
  }

  @action.bound
  getOwnerNameOptions() {
    this.setLoading(true);

    return this.graphqlQueryService
      .query({
        query: GET_HOME_OWNER_NAMES,
        fetchPolicy: "no-cache",
        variables: {
          property_id: this.propertyId
        }
      })
      .then(
        action(({ data }) => {
          this.ownerNameOptions = data.home_claim.owner_names;
          this.setLoading(false);
        })
      )
      .catch(error => {
        this.setLoading(false);
        this.setError(error);
      });
  }

  handleOwnerNameSubmit(formValues, { onError }) {
    this.setHasCompletedValidation(false);

    return this.graphqlMutationService
      .mutate({
        mutation: VALIDATE_HOME_CLAIM,
        variables: {
          property_id: this.propertyId,
          user_id: this.userId,
          ...ownerNameToGraphQL(formValues)
        }
      })
      .then(() => {
        this.setHasCompletedValidation(true);
        this.setError(null);
      })
      .then(() => {
        const slot = getSelectedNameSlot(formValues, this.ownerNameOptions);
        this.analyticsService.sendOwnerNameSelected({ slot });
      })
      .catch(error => {
        this.setError(error);
        onError(error);
      });
  }
}

export default ValidationStore;
